import { SortOrder } from '@/Enums/SortOrder';
import { Sort } from '@/Utils/Filters/FilterHelper';

export const generateSort = <T = never>(key: keyof T & string, order: SortOrder): Sort<T> => {
    return order === SortOrder.Asc ? `+${key}` : `-${key}`;
};
